import { Link } from "react-router-dom";
import { ClipboardCheck, AlertTriangle, ListChecks, User, Gauge } from "lucide-react";
import { STATUS_META } from "./StatusBadge";
import { Button } from "./ui/button";
import { APP } from "../constants/testIds";

const fmtDate = (d, h) => (d ? `${d.split("-").reverse().join("/")}${h ? " à " + h : ""}` : "—");

export const FrontCard = ({ front }) => {
  const etat = front.etat || {};
  const status = etat.Statut_Global || "AUTORISEE";
  const meta = STATUS_META[status];
  const Icon = meta.icon;
  const critiques = Number(etat.Nb_Anomalies_Critiques || 0);
  const anomalies = Number(etat.Nb_Anomalies_Ouvertes || 0);
  const actions = Number(etat.Nb_Actions_Ouvertes || 0);

  return (
    <div
      data-testid={APP.statusCardFront(front.Front_ID)}
      className={`relative rounded-2xl border-2 ${meta.border} ${meta.solidBg} p-5 flex flex-col gap-4 ${meta.glow} transition-transform hover:-translate-y-0.5`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-400 mb-1">{front.Front_ID}</div>
          <h3 className="text-lg font-black uppercase tracking-tight text-slate-50">{front.Front_Libelle}</h3>
        </div>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${meta.badge} border`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>

      <span className={`inline-flex self-start items-center gap-1.5 rounded-full border px-3 py-1 font-bold uppercase tracking-wide text-[11px] ${meta.badge}`}>
        {meta.emoji} {meta.label}
      </span>

      {status === "SUSPENDUE" && critiques > 0 && (
        <div className="flex items-center gap-2 text-red-300 text-xs font-bold uppercase tracking-wide bg-red-500/10 border border-red-500/40 rounded-lg px-3 py-2">
          <AlertTriangle className="w-4 h-4 shrink-0" /> {critiques} anomalie{critiques > 1 ? "s" : ""} critique{critiques > 1 ? "s" : ""} ouverte{critiques > 1 ? "s" : ""}
        </div>
      )}

      <div className="grid grid-cols-2 gap-3 text-sm">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Dernière inspection</div>
          <div className="text-slate-200 font-semibold">{fmtDate(etat.Date_Derniere_Inspection, etat.Heure_Derniere_Inspection)}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1"><User className="w-3 h-3" /> Inspecteur</div>
          <div className="text-slate-200 font-semibold">{etat.Dernier_Inspecteur || "—"}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1"><Gauge className="w-3 h-3" /> Score</div>
          <div className="text-slate-200 font-semibold">{etat.Dernier_Score !== undefined && etat.Dernier_Score !== "" ? `${etat.Dernier_Score}%` : "—"}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1"><ListChecks className="w-3 h-3" /> Actions ouvertes</div>
          <div className="text-slate-200 font-semibold">{actions}</div>
        </div>
      </div>

      <div className="flex items-center justify-between text-xs text-slate-400 border-t border-white/5 pt-3">
        <span className="flex items-center gap-1"><ClipboardCheck className="w-3.5 h-3.5" /> Anomalies ouvertes: <b className="text-slate-200">{anomalies}</b></span>
      </div>

      <div className="flex gap-2 mt-auto">
        {status === "SUSPENDUE" ? (
          <>
            <Link to={`/front/${front.Front_ID}?tab=historique`} className="flex-1">
              <Button data-testid={`front-card-view-inspection-${front.Front_ID}`} className="w-full bg-red-600 hover:bg-red-500 text-white font-bold uppercase text-xs">
                Voir l'inspection
              </Button>
            </Link>
            <Link to={`/front/${front.Front_ID}?tab=actions`} className="flex-1">
              <Button data-testid={`front-card-view-actions-${front.Front_ID}`} variant="outline" className="w-full border-red-500/50 text-red-300 font-bold uppercase text-xs">
                Voir les actions
              </Button>
            </Link>
          </>
        ) : status === "RESERVES" ? (
          <Link to={`/front/${front.Front_ID}?tab=anomalies`} className="flex-1">
            <Button data-testid={`front-card-view-anomalies-${front.Front_ID}`} className="w-full bg-amber-500 hover:bg-amber-400 text-black font-bold uppercase text-xs">
              Voir les anomalies
            </Button>
          </Link>
        ) : (
          <Link to={`/front/${front.Front_ID}`} className="flex-1">
            <Button data-testid={`front-card-view-front-${front.Front_ID}`} className="w-full bg-emerald-500 hover:bg-emerald-400 text-black font-bold uppercase text-xs">
              Voir le front
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};
